import { readJsonFile } from '../fs';
import { dictionaryResolverFs } from './dictionaryResolverFs';
import { dictionaryWatcherFs } from './dictionaryWatcherFs';
import { hasPathToLeaf } from './hasPathToLeaf';
import { traverseLeaves } from './traverseLeaves';
export class DictionaryController {
    static getControllerFs({ localePath, locale, reader = readJsonFile, watchMode = false, // watch only when run by vscode-eslint, command line should not watch which would cause eslint not exit
     }) {
        return new DictionaryController(() => dictionaryResolverFs(localePath, locale, reader), ({ multiSources, localePath, updateDictionary }) => dictionaryWatcherFs({
            multiSources,
            localePath,
            updateDictionary,
            watchMode,
            reader,
        }));
    }
    static getControllerSingletonFs(opts) {
        var _a;
        return (DictionaryController.singletonFs =
            (_a = DictionaryController.singletonFs) !== null && _a !== void 0 ? _a : DictionaryController.getControllerFs(opts));
    }
    constructor(resolver, watcher) {
        this.dictionary = {};
        this.destroy = () => {
            var _a;
            (_a = this.closeWatcher) === null || _a === void 0 ? void 0 : _a.call(this);
        };
        this.hasPathToLeaf = (path, nsDivider, keyDivider) => {
            return hasPathToLeaf({
                dictionary: this.dictionary,
                path,
                nsDivider,
                keyDivider,
            });
        };
        this.traverse = (cb, nsDivider, keyDivider) => {
            return traverseLeaves({
                dictionary: this.dictionary,
                nsDivider,
                keyDivider,
                cb,
            });
        };
        const { multiSources, localePath, dictionary } = resolver();
        this.dictionary = dictionary !== null && dictionary !== void 0 ? dictionary : this.dictionary;
        this.closeWatcher = watcher === null || watcher === void 0 ? void 0 : watcher({
            multiSources,
            localePath,
            updateDictionary: (newDict, reset) => {
                this.dictionary = reset
                    ? Object.assign({}, newDict) : Object.assign(Object.assign({}, this.dictionary), newDict);
            },
        });
    }
}
